import React from "react"

import { ScrollContextProvider } from "contexts/Scroll"
import Layout from "layouts/Layout"
import Video from "components/Video"
import ImageSlider from "components/ImageSlider"
import Home from "components/Home"
import Content from "components/Content"
import Footer from "components/Footer"

const IndexPage = () => {
  return (
    <ScrollContextProvider>
      <Layout>
        <Video />
        <ImageSlider />
        <Home />
        <Content />
        <Footer />
      </Layout>
    </ScrollContextProvider>
  )
}

export default IndexPage
